import ProcessLogsBase from './ProcessLogsComponents/ProcessLogsBase'

const BrandsProcessLogs = () => {
  return (
    <div>
        <ProcessLogsBase />
    </div>
  )
}

export default BrandsProcessLogs